import { render, staticRenderFns } from "./Collapsible.vue?vue&type=template&id=5f26172c&scoped=true&"
import script from "./Collapsible.vue?vue&type=script&lang=js&"
export * from "./Collapsible.vue?vue&type=script&lang=js&"
import style0 from "./collapsible.scss?vue&type=style&index=0&id=5f26172c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f26172c",
  null
  
)

export default component.exports